import React, { useState } from 'react';
import { Card, CardHeader, CardContent } from '../ui/card';
import { FormGroup, FormLabel, FormInput } from '../ui/form';
import { Button } from '../ui/button';
import { Shield, ArrowLeft } from 'lucide-react';

const MfaChallenge = ({ 
  onVerify, 
  onCancel, 
  loading = false, 
  error = null 
}) => {
  const [verificationCode, setVerificationCode] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (verificationCode.length === 6) {
      onVerify(verificationCode);
    }
  };

  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <h1 className="text-center text-2xl font-bold text-gray-900 dark:text-gray-100 flex items-center justify-center gap-2">
          <Shield className="w-6 h-6" />
          Two-Factor Authentication
        </h1>
        <p className="text-center text-sm text-gray-600 dark:text-gray-400">
          Enter the 6-digit code from your authenticator app to complete sign in.
        </p>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-6">
          <FormGroup>
            <FormLabel htmlFor="verification-code">
              Verification Code
            </FormLabel>
            <FormInput
              id="verification-code"
              type="text"
              placeholder="000000"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              maxLength={6}
              required
              className="text-center text-lg tracking-wider"
              autoComplete="one-time-code"
              autoFocus
            />
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              Enter the code from your authenticator app
            </p>
          </FormGroup>
          
          {error && (
            <div className="rounded-md bg-red-50 dark:bg-red-900/20 p-4">
              <p className="text-sm text-red-700 dark:text-red-400">{error}</p>
            </div>
          )}
          
          <div className="space-y-3">
            <Button
              type="submit"
              disabled={loading || verificationCode.length !== 6}
              className="w-full"
            >
              {loading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Verifying...
                </>
              ) : (
                'Verify'
              )}
            </Button>
            
            <Button
              type="button"
              variant="outline"
              onClick={onCancel}
              disabled={loading}
              className="w-full flex items-center justify-center gap-2"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Login
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};

export default MfaChallenge;
